import CollectionCreateFrontLink from './collection-create-front-link';

export default CollectionCreateFrontLink;